import { useP2GDebounce } from '@parcel2go/core-ui';
import { useEffect, useRef, useState } from 'react';

function useVisible() {
  const [realtimeVisible, setRealtimeVisible] = useState(true);
  const [visible, setVisible] = useP2GDebounce(true, realtimeVisible ? 1000 : 30000);
  const lastVisibleRef = useRef(true);
  useEffect(() => {
    const f = () => {
      const next = document.visibilityState !== 'hidden';
      if (lastVisibleRef.current === next) return;
      lastVisibleRef.current = next;
      setVisible(next);
      setRealtimeVisible(next);
    };
    window.addEventListener('visibilitychange', f);
    return () => window.removeEventListener('visibilitychange', f);
  }, [setVisible]);

  useEffect(() => {
    console.log(visible ? 'Powering Up Api Calls' : 'Powering Down Api Calls');
  }, [visible]);

  return [visible] as const;
}
export { useVisible };
